import { Component, OnInit, HostListener, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
declare const clevertap;

interface CompanyItem {
  quick_comparision_id: number;
  quick_comparision_name: string;
  company_elastic_id: string;
  company_elastic_name: string;
  company_name: string;
  orderid: number;
  suborderid: number;
  isactive: number;
  createdon: string;
  companylogo?: string;
}

interface CompanyGroup {
  orderid: number;
  rows: { first: CompanyItem, second: CompanyItem }[];
}
@Component({
    selector: 'app-company-comparison-slider',
    templateUrl: './company-comparison-slider.component.html',
    styleUrls: ['./company-comparison-slider.component.scss'],
    standalone: false
})

export class CompanyComparisonSliderComponent implements OnInit {


  slidersData: any;
  sliders: any;
  @Input() groupIndex: number = 0;
  index: any = {};
  constructor(private companyInsightsService: CompanyInsightsService, private personServiceService: PersonSearchService, private localStorageService: LocalStorageService,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.index = {
      1: [1, 2],
      2: [3, 4],
      3: [5, 6],
      4: [7, 8],
      5: [9, 10],
      6: [11, 12],
      7: [13, 14],
      8: [15, 16],
      9: [17, 18],
      10: [19, 20],
      11: [21, 22],
      12: [23, 24],
      13: [25, 26],
      14: [27, 28],
      15: [29, 30]
    }
    this.getSuggestedCompanies();
  }

  async getSuggestedCompanies(): Promise<void> {
    const response: any = await this.companyInsightsService.suggestedCompanyCompare().toPromise();
    if (response && response.status === 'success') {
      this.slidersData = response.data;
      await this.getCompanyLogo(this.slidersData);
      const loopedIndex = this.groupIndex > 15 ? ((this.groupIndex - 1) % 15) + 1 : this.groupIndex;
      this.sliders = this.prepareMergedGroups(this.slidersData, [this.index[loopedIndex]]);
    }

  }



  prepareMergedGroups(data: any[], orderGroups: number[][]): any[] {
    const result = [];

    for (const group of orderGroups) {
      const combinedItems = data
        .filter(item => group.includes(item.orderid))
        .sort((a, b) => a.orderid - b.orderid || a.suborderid - b.suborderid);
      const rows = [];
      for (let i = 0; i < combinedItems.length; i += 2) {
        rows.push({
          first: combinedItems[i],
          second: combinedItems[i + 1] || null
        });
      }

      result.push({
        group: group.join('_'),
        rows
      });
    }

    return result;
  }

  async getCompanyLogo(combinedItems): Promise<void> {
    let companyLogoPayload = combinedItems.map(item => {
      if (item.company_name || item.company_elastic_id) {
        return {
          ...(item?.company_elastic_id && { id: item.company_elastic_id }),
          ...(item?.company_name && { name: item.company_name })
        }
      }
    }).filter(Boolean);

    return new Promise(resolve => {
      companyLogoPayload?.length &&
      this.personServiceService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
        if (res && res.status == "success") {

          this.slidersData = this.slidersData.map(c => ({
            ...c, companylogo: res.data.filter(r =>
              (r.id === c.company_elastic_id))[0].companylogo
          }));
        }
        resolve();
      })
    });
  }

  openCompanyCompare(row) {
    this.localStorageService.setItem('companyOneId', row.first.company_elastic_id);
    this.localStorageService.setItem('companyTwoId', row.second?.company_elastic_id);
     const data = {
    companies: [row.first.company_name, row.second?.company_name],
    id: [row.first.company_elastic_id, row.second?.company_elastic_id],
    }
    this.setCompanyInsightsHistory(data, 'company');
    const companyInsightsParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "Company Name 1": row.first.company_name,
      "Company Name 2": row.second?.company_name,
      "Source": "Listing"
    }
    clevertap.event.push("Company Comparison Performed", companyInsightsParams);
    this.router.navigateByUrl('/company-compare')
  }

  setCompanyInsightsHistory(data, selectionType: string) {
    const payload = {
      ...((selectionType === 'company') && {
        companies: data.companies,
        companyids:
          data.id
      }),
      module: GlobalService.HISTORY_MODULE.COMPANY_COMPARISON
    }
    this.personServiceService.setInsightsHistory(payload).subscribe();
  }



}
